let isV2Routing = false;

export const getIsV2Routing = () => isV2Routing;

export const setIsV2Routing = (value) => {
  isV2Routing = value;
};
